export default "__VITE_ASSET__281d33ee__"